export class DialogTypes {
  static PRODUCT: string = 'product';
  static PRODUCT_ARTICLE: string = 'productArticle';
  static MOVIE: string = 'movie';
  static STATEMENT_MOVIE: string = 'statementMovie';
}
